/* Shop-Übersicht: Filter (Gruppen), Sortierung, Nummern neu setzen, Einblend-Animation */
(function () {
  'use strict';
  document.querySelectorAll('.tsh-section').forEach(function (sec) {
    var grid = sec.querySelector('.tsh-grid');
    if (!grid) return;
    var cards = [].slice.call(grid.querySelectorAll('.tsh-card'));
    var bar = sec.querySelector('.tsh-toolbar');
    var select = sec.querySelector('.tsh-sort select');
    var fbtns = [].slice.call(sec.querySelectorAll('.tsh-fbtn'));
    var state = { group: '*', sort: 'pos' };
    var featureFirst = grid.getAttribute('data-first') === '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sec.classList.add('tsh-js');
    if (bar) bar.hidden = false;

    function cmp(a, b) {
      if (state.sort === 'az') return a.dataset.name.localeCompare(b.dataset.name, 'de');
      if (state.sort === 'count') return (parseInt(b.dataset.tshCount, 10) - parseInt(a.dataset.tshCount, 10)) || (a.dataset.pos - b.dataset.pos);
      return a.dataset.pos - b.dataset.pos;
    }

    function apply() {
      var list = cards.slice().sort(cmp);
      var i = 0, firstShown = null;
      list.forEach(function (c) {
        grid.appendChild(c);
        var show = state.group === '*' || c.dataset.group === state.group;
        c.hidden = !show;
        c.classList.remove('is-first');
        if (show) {
          i++;
          var num = c.querySelector('.tsh-num');
          if (num) num.textContent = (i < 10 ? '0' : '') + i;
          if (!firstShown) firstShown = c;
        }
      });
      /* "Erste Kachel groß" nur in der Standardansicht ohne Filter/Sortierung */
      if (featureFirst && firstShown && state.group === '*' && state.sort === 'pos') firstShown.classList.add('is-first');
    }

    fbtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        fbtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        state.group = btn.dataset.group;
        apply();
      });
    });
    if (select) select.addEventListener('change', function () { state.sort = select.value; apply(); });

    /* Einblenden beim Scrollen */
    var visibleIdx = 0;
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          el.style.transitionDelay = Math.min(visibleIdx++ % 6, 5) * 70 + 'ms';
          el.classList.add('tsh-in');
          io.unobserve(el);
          setTimeout(function () { el.style.transitionDelay = ''; }, 900);
        });
        visibleIdx = 0;
      }, { threshold: 0.08 });
      cards.forEach(function (c) { io.observe(c); });
    } else {
      cards.forEach(function (c) { c.classList.add('tsh-in'); });
    }
  });
})();
